import axios from "axios";
import { REACT_APP_API } from "../constants";
import { requestsFor } from "./headerService";

// Database → Access Logs: every database login decision through the AuthNull
// proxy (authnull-service internal/database/accesslog). Administrators only.
//
//   POST /api/v1/databaseService/accessLog/list
//     { email?, dbUser?, database?, decision?, reasonCode?, clientIp?, from?, to?, page, pageSize }
//   → { total, page, pageSize, events: [...] }   newest first
//
// The org comes from the session, so orgId is never sent. The reply has no
// code/status envelope, so any 2xx is success; errors are { error }.
const requests = requestsFor(axios.create({ baseURL: `${REACT_APP_API}/api/v1/databaseService` }));

export function listDbAccessLog({ payload = {}, onSuccess, onFailure }) {
  const { orgId, OrgId, ...body } = payload; // eslint-disable-line no-unused-vars
  return requests
    .post("/accessLog/list", body)
    .then((res) => onSuccess && onSuccess(res?.data || {}))
    .catch((err) => onFailure && onFailure(err));
}

/** A readable sentence for a failed listing. */
export function dbAccessLogErrorText(err) {
  const status = err?.response?.status;
  if (status === 403) return "Only administrators can see access logs.";
  if (status === 401) return "Your session has expired. Sign in again.";
  return err?.response?.data?.error || "Couldn't load the database access logs.";
}
